module.exports = "pegasus_template/assets/complex_library_block.png";